module.exports = __webpack_public_path__ + "static/media/Serenity soffa 4sits Sense 4001 beige miljö modell 2024 2.1bb7eb8d.jpg";